// lang-es.ts

export const LANG_FR_NAME = 'fr';

export const LANG_FR_TRANS = {
  'msgConnect': 'Se connecter à JuJu',
  'username': 'Courriel ou nom d\'utilisateur',
  'password': 'Mot de passe',
  'login': 'Se connecter',
  'requiredUsername': 'Nom d\'utilisateur requis',
  'requiredPassword': 'Mot de passe requis',
  'errorConnexion': 'Le nom d\'utilisateur ou le mot de passe est incorrect',
  // Navbar''
    'Infos':'Projet',
  'logout': 'Se déconnecter',
  'respondents': 'Répondants',
  'statistics': 'Statistiques',
  'searchFilter': 'Filtre de recherche',
  'Terminal': 'Terminal',
  // search
  'search...': 'Chercher...',
  'erase': 'Effacer',
  'save': 'Sauvegarder',
  'addChoice':'Ajouter Choix',
  'add': 'Ajouter',
  'dates': 'Dates',
  'synchro': 'Synchro',
  'emailStatus': 'État du courriel',
  'answer': 'Réponse',
  // download
  'douwnload': 'Télécharger',
  'excelReport': 'Rapport Excel',
    'htmlReport': 'Rapport HTML',
  'pictures': 'Photos',
  'gifs': 'Gifs',
  'picturesAnim': 'Photos animés',
  'videos': 'Vidéos',
  // respondent
  'synchroTime': 'Temps de synchronisation',
  'savedTime': 'Temps épargné',
  'details': 'Détails',
  // respondent by synchro
  'time': 'Temps',
  'user': 'Utilisateur',
  'device': 'Terminal',
  // Statistics
  'general': 'Général',
  'total': 'Total',
  'totalRespondents': 'Total des répondants',
  'emailSent': 'Email envoyé',
  'emailOpened': 'Email ouvert',
  'smsSent': 'SMS envoyés',
  'clicks': 'Clics',
  'from': 'De',
  'send': 'Envoyer',
  'report':'Rapport',
  // Project Infos
  'startDate' : 'Date Début',
  'endDate' : 'Date Fin',
  'projectName' : 'Nom',
  'projectCode' : 'Code',
  'projectClient' : 'Client',
  'projectUserName' : 'Nom utilisateur',
  'projectPassword' : 'Mot de Passe',
  'projectTags' : 'Tags',
  'new' : 'Nouveau...',
  // Questionnaire Infos
    'title' : 'Title',
    'sms' : 'Sms',
    'email' : 'Email',
    'languages' : 'Langues supportées',
    'picture_transformation' : 'Transformation Image',
    'hashtag_subscription' : 'Souscription Hashtag',
    'files' : 'Fichiers'
};
